import { SDKOptions, SportTypes, IOddsBaseConfig } from '../../types';
import { getLanguageParam } from '../../utils';
import { generateRequest } from '../http.service';

export interface ITimelineProps extends IOddsBaseConfig {
  idOrSlug?: string;
}

export const getMatchEvents = async ({ params, sdkOptions }: { params: ITimelineProps; sdkOptions: SDKOptions }) => {
  const url = `${sdkOptions.dataConfigApiUrl}/v2/matches/${params.idOrSlug}/events`;

  const baseParams = {
    sport: SportTypes.FOOTBALL,
    language_code: getLanguageParam(sdkOptions.dataConfigLang),
  };

  const requestParams = {
    ...baseParams,
  };

  return await generateRequest(url, requestParams, sdkOptions);
};
